<admin-header [primaryButtons]="headerPrimaryButtons" [tertiaryButtons]="headerTertiaryButtons" [title]="title" (eventFired)="headerButtonClick($event)"></admin-header>
<div *ngIf="parsedTextPopupVisible" class="edi-modal-backdrop" (click)="closeParsedTextPopup()">
	<div class="edi-modal" (click)="$event.stopPropagation()">
		<div class="edi-modal-header">
			<span class="edi-modal-title">Parsed Message Contents</span>
			<div class="edi-modal-actions">
				<button class="edi-modal-copy" (click)="copyParsedText()" [class.copied]="parsedTextCopied">{{ parsedTextCopied ? '✓ Copied' : 'Copy to Clipboard' }}</button>
				<button class="edi-modal-close" (click)="closeParsedTextPopup()">✕</button>
			</div>
		</div>
		<div class="edi-modal-body">
			<pre class="edi-text-block">{{ item.parsedEdiMessageContents }}</pre>
		</div>
	</div>
</div>
<div *ngIf="ediTextPopupVisible" class="edi-modal-backdrop" (click)="closeEdiTextPopup()">
	<div class="edi-modal" (click)="$event.stopPropagation()">
		<div class="edi-modal-header">
			<span class="edi-modal-title">EDI Message Text</span>
			<div class="edi-modal-actions">
				<button class="edi-modal-copy" (click)="copyEdiText()" [class.copied]="ediTextCopied">{{ ediTextCopied ? '✓ Copied' : 'Copy to Clipboard' }}</button>
				<button class="edi-modal-close" (click)="closeEdiTextPopup()">✕</button>
			</div>
		</div>
		<div class="edi-modal-body">
			<pre class="edi-text-block">{{ formattedEdiText }}</pre>
		</div>
	</div>
</div>
<div class="form-container">
	<div class="shipping-note-summary m-3">
		<h5 class="summary-title">Details</h5>
		<div class="summary-details">
			<div class="summary-row">
				<span class="summary-label">Message Type</span>
				<span>{{ messageTypeLabel }}</span>
			</div>
			<div class="summary-row">
				<span class="summary-label">Message Direction</span>
				<span>{{ messageDirectionLabel }}</span>
			</div>
			<div class="summary-row">
				<span class="summary-label">Status</span>
				<span>{{ statusLabel }}</span>
			</div>
			<div class="summary-row">
				<span class="summary-label">Message Reference</span>
				<span>{{ item.messageReference || '—' }}</span>
			</div>
			<div class="summary-row">
				<span class="summary-label">Sender ID</span>
				<span>{{ item.senderId || '—' }}</span>
			</div>
			<div class="summary-row">
				<span class="summary-label">Recipient ID</span>
				<span>{{ item.recipientId || '—' }}</span>
			</div>
		</div>
		<div *ngIf="item.parsedEdiMessageContents" class="detail-full-row">
			<span class="summary-label">Parsed EDI Message Contents</span>
			<span class="detail-text-value">{{ item.parsedEdiMessageContents }}</span>
		</div>
		<div *ngIf="item.failureMessage" class="detail-full-row">
			<span class="summary-label">Failure Message</span>
			<span class="detail-text-value detail-failure">{{ item.failureMessage }}</span>
		</div>
	</div>
	<div *ngIf="isOutgoingShippingNote" class="shipping-note-summary m-3">
		<h5 class="summary-title">Shipping Note Summary</h5>
		<div class="summary-details">
			<div class="summary-row">
				<span class="summary-label">ASN Number</span>
				<span>{{ shippingNoteSummary.asnNumber }}</span>
			</div>
			<div class="summary-row">
				<span class="summary-label">Shipping Reference</span>
				<span>{{ shippingNoteSummary.shippingReference }}</span>
			</div>
			<div class="summary-row">
				<span class="summary-label">Creation Date</span>
				<span>{{ shippingNoteSummary.creationDate }}</span>
			</div>
			<div class="summary-row">
				<span class="summary-label">Est. Arrival Date</span>
				<span>{{ shippingNoteSummary.estimatedArrivalDate }}</span>
			</div>
			<div class="summary-row">
				<span class="summary-label">Gross Weight</span>
				<span>{{ shippingNoteSummary.grossWeight }} KG</span>
			</div>
			<div class="summary-row">
				<span class="summary-label">Net Weight</span>
				<span>{{ shippingNoteSummary.netWeight }} KG</span>
			</div>
		</div>
		<table *ngIf="shippingNoteSummary.lineItems.length > 0" class="summary-table">
			<thead>
				<tr>
					<th class="expand-col"></th>
					<th>Part Number</th>
					<th>Order Reference</th>
					<th>Despatched Qty</th>
					<th>Cumulative Qty</th>
					<th>Pallets / Lids</th>
					<th>Containers (Parts)</th>
					<th>Pack Factor</th>
					<th>Empty Containers</th>
					<th>Returnable</th>
				</tr>
			</thead>
			<tbody>
				<ng-container *ngFor="let lineItem of shippingNoteSummary.lineItems; let i = index">
					<tr (click)="toggleRow(i)" class="summary-data-row" [class.row-expanded]="expandedRows.has(i)">
						<td class="expand-col">
							<span class="expand-chevron">{{ expandedRows.has(i) ? '▼' : '▶' }}</span>
						</td>
						<td>{{ lineItem.partNumber }}</td>
						<td>{{ lineItem.orderRef }}</td>
						<td>{{ lineItem.despatchedQty }}</td>
						<td>{{ lineItem.cumulativeQty }}</td>
						<td>
							<ng-container *ngIf="lineItem.palletCount || lineItem.lidCount; else noPalletOrLid">
								<div *ngIf="lineItem.palletCount">
									{{ lineItem.palletCount }}<span *ngIf="lineItem.palletCode" class="pack-code"> ({{ lineItem.palletCode }})</span>
								</div>
								<div *ngIf="lineItem.lidCount">
									{{ lineItem.lidCount }}<span *ngIf="lineItem.lidCode" class="pack-code"> ({{ lineItem.lidCode }})</span>
									<span *ngIf="lineItem.lidCount !== lineItem.palletCount" class="pack-mismatch" title="Lid count does not match pallet count"> ⚠️</span>
								</div>
							</ng-container>
							<ng-template #noPalletOrLid>—</ng-template>
						</td>
						<td>{{ lineItem.boxCount || '—' }}<span *ngIf="lineItem.boxCode" class="pack-code"> ({{ lineItem.boxCode }})</span></td>
						<td>{{ lineItem.packFactor || '—' }}</td>
						<td>{{ lineItem.emptyBoxCount || '—' }}</td>
						<td class="returnable-cell">
							<span [class]="lineItem.isReturnable ? 'returnable-yes' : 'returnable-no'">{{ lineItem.isReturnable ? '✓' : '✗' }}</span>
						</td>
					</tr>
					<tr *ngIf="expandedRows.has(i)" class="expanded-labels-row">
						<td colspan="10">
							<div class="label-groups">
								<div *ngIf="lineItem.palletLabels.length > 0" class="label-group">
									<span class="label-group-title">Pallets</span>
									<div class="label-chips">
										<span *ngFor="let label of lineItem.palletLabels" class="label-chip pallet-chip">{{ label }}</span>
									</div>
								</div>
								<div *ngIf="lineItem.boxLabels.length > 0" class="label-group">
									<span class="label-group-title">Boxes</span>
									<div class="label-chips">
										<span *ngFor="let box of lineItem.boxLabels" class="label-chip box-chip">
											{{ box.label }}<span *ngIf="box.qty" class="label-qty"> · {{ box.qty }} pcs</span>
										</span>
									</div>
								</div>
								<span *ngIf="lineItem.palletLabels.length === 0 && lineItem.boxLabels.length === 0" class="no-labels">No container labels found</span>
							</div>
						</td>
					</tr>
				</ng-container>
			</tbody>
		</table>
	</div>
</div>